import { IAPIActionBase } from "us.common/interfaces";
import { SystemCredentialsActionTypes } from "us.common/constants";

const {
  GET_SYSTEM_CREDENTIALS,
  GET_SYSTEM_CREDENTIALS_SUCCESS,
  GET_SYSTEM_CREDENTIALS_FAIL,
} = SystemCredentialsActionTypes;

export const SystemCredentialsAction: Readonly<IAPIActionBase> = {
  systemCredentials: {
    get: (data) => ({
      type: GET_SYSTEM_CREDENTIALS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_SYSTEM_CREDENTIALS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_SYSTEM_CREDENTIALS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
